import { GrowthPathAppraisal } from '../types';

type CompetencyProgress = 'on-track' | 'above-level' | 'below-level';

export function useCompetencyProgress(
	appraisal: GrowthPathAppraisal | null,
	min: number,
): { progress: CompetencyProgress; level: number } | undefined {
	if (!appraisal) {
		return undefined;
	}

	const level = Math.round(appraisal.competencyLevelIndex);

	if (min > level) {
		return { progress: 'below-level', level };
	}

	if (min === level) {
		return { progress: 'on-track', level };
	}

	if (min < level) {
		return { progress: 'above-level', level };
	}

	return undefined;
}
